module.exports = __webpack_public_path__ + "static/media/Machine.ce26eb7c.svg";